export default __webpack_public_path__ + "static/media/Georgia 9781846161681.a7076a12.jpg";